import { IconArchive, IconDots, IconEdit, IconGripVertical } from '@tabler/icons-react'
import { useState } from 'react'

import { AstraButton, AstraDropdownItem, AstraDropdownMenu, AstraIcon, AstraParagraph, astraTwMerge } from '~/astra'
import { usePractitionerStatusDefinition } from '~/storm'

import { StatusDefinitionForm } from './StatusDefinitionForm/StatusDefinitionForm'

export type StatusItemProps = {
    code: string
}

export const StatusItem = ({ code }: StatusItemProps) => {
    const [openDialog, setOpenDialog] = useState(false)
    const [openDropdown, setOpenDropdown] = useState(false)

    const practitionerStatus = usePractitionerStatusDefinition({ where: { code } })

    if (!practitionerStatus) return null

    return (
        <>
            <StatusDefinitionForm
                key="edit-form"
                assignmentName={practitionerStatus.assignment}
                statusDefinition={practitionerStatus}
                open={openDialog}
                setOpen={setOpenDialog}
            />

            <div className="group relative flex items-center gap-2 rounded-md py-1 pr-3 transition-all">
                <div
                    className={astraTwMerge(
                        'absolute -left-4 flex cursor-grab items-center justify-center text-subtle opacity-0 group-hover:opacity-100',
                        openDropdown ? 'opacity-100' : ''
                    )}
                >
                    <AstraIcon icon={IconGripVertical} size="small" />
                </div>

                <div
                    className="inline-flex min-w-11 items-center justify-center rounded-md px-2 py-0.5 text-body-small font-hero-medium leading-body-small text-default"
                    style={{ backgroundColor: practitionerStatus.color }}
                >
                    {practitionerStatus.label}
                </div>

                <AstraParagraph className="text-default">{practitionerStatus.title}</AstraParagraph>

                <div className={astraTwMerge('ml-auto opacity-0 group-hover:opacity-100', openDropdown ? 'opacity-100' : '')}>
                    <AstraDropdownMenu
                        placement="right-start"
                        open={openDropdown}
                        onOpenChange={setOpenDropdown}
                        dropdownContent={
                            <div className="w-44">
                                <AstraDropdownItem option={{ type: 'action', title: 'Rediger', icon: IconEdit, action: () => setOpenDialog(true) }} />
                                <AstraDropdownItem option={{ type: 'action', title: 'Arkiver', icon: IconArchive, disabled: true }} />
                            </div>
                        }
                    >
                        <AstraButton
                            variant="ghost"
                            size="medium"
                            icon={<AstraIcon icon={IconDots} />}
                            aria-label={`Vis handlinger for ${practitionerStatus.title}`}
                        />
                    </AstraDropdownMenu>
                </div>
            </div>
        </>
    )
}
